const images = {
  purple_kindred_icon: require('../Assets/Branding/purple_kindred_icon.png'),
  black_kindred_icon: require('../Assets/Branding/black_kindred_icon.png'),
  new_kindred_icon: require('../Assets/Branding/new_kindred_icon.png'),
  itv_logo: require('../Assets/Branding/itv_logo.png'),
  discounts_and_savings_icon: require('../Assets/Branding/discounts-and-savings.png'),
  keyboard_installation_guide_ios: require('../Assets/KeyboardInstallationGuide/ios.png'),
  keyboard_installation_guide_android: require('../Assets/KeyboardInstallationGuide/android.png'),
  nike_logo: require('../Assets/BrandLogos/nike.png'),
  aliexpress_logo: require('../Assets/BrandLogos/aliexpress.png'),
  john_lewis_logo: require('../Assets/BrandLogos/john_lewis.png'),
  asos_logo: require('../Assets/BrandLogos/asos.png'),
  nike_logo_white: require('../Assets/BrandLogos/nike_logo_white.png'),
  john_lewis_logo_white: require('../Assets/BrandLogos/john_lewis_logo_white.png'),
  asos_logo_white: require('../Assets/BrandLogos/asos_logo_white.png'),
  typewise: require('../Assets/BrandLogos/typewise.png'),
  couponsde: require('../Assets/BrandLogos/couponsde.png'),
  eon: require('../Assets/BrandLogos/eon.png'),
  popreach: require('../Assets/BrandLogos/popreach.png'),
  whitelabel: require('../Assets/BrandLogos/whitelabel.png'),
  adscend: require('../Assets/BrandLogos/adscend.png'),
  teamo: require('../Assets/BrandLogos/teamo.png'),
  o2: require('../Assets/BrandLogos/o2.png'),
  unity: require('../Assets/BrandLogos/unity.png'),
  O2_logo: require('../Assets/O2Logos/O2-bubble-3D-animations-04@05x 1.png'),
  partnerpluginsdk_activate_settings_activate_kindred: require('../Assets/PartnerpluginsdkActivate/settings activate kindred.png'),
  partnerpluginsdk_activate_settings_menu: require('../Assets/PartnerpluginsdkActivate/settings menu.png'),
  partnerpluginsdk_activate_settings_permission: require('../Assets/PartnerpluginsdkActivate/settings permission.png'),
  plugin_alpha_step_2: require('../Assets/KeyboardInstallationGuide/plugin-alpha-step2.jpg'),
  plugin_alpha_step_3: require('../Assets/KeyboardInstallationGuide/plugin-alpha-step3.jpg'),
  plugin_beta_step_1: require('../Assets/KeyboardInstallationGuide/plugin-beta-step1.gif'),
  plugin_beta_step_2: require('../Assets/KeyboardInstallationGuide/plugin-beta-step2.gif'),
  plugin_beta_step_3: require('../Assets/KeyboardInstallationGuide/plugin-beta-step3.gif'),
  mobile: require('../Assets/Products/mobile.png'),
  unity_logo: require('../Assets/Products/unity.png'),
  deals_api: require('../Assets/Products/dealsApi.png'),
  desktop_extension: require('../Assets/Products/desktopExtension.png'),
  mobile_keyboard: require('../Assets/Products/mobileKeyboard.png'),
  edge_icon: require('../Assets/Products/edge.png'),
  chrome_icon: require('../Assets/Platforms/chrome.png'),
  firefox_icon: require('../Assets/Products/firefox.png'),
  safari_icon: require('../Assets/Products/safari.png'),
  android_guide_1: require('../Assets/KeyboardInstallationGuide/android-guide1.png'),
  android_guide_2: require('../Assets/KeyboardInstallationGuide/android-guide2.png'),
  android_guide_3: require('../Assets/KeyboardInstallationGuide/android-guide3.png'),
  esg_icon_1: require('../Assets/Esg/reforestation.png'),
  esg_icon_2: require('../Assets/Esg/carbonOffset.png'),
  esg_icon_3: require('../Assets/Esg/donate.png'),
  revenue_icon_1: require('../Assets/Revenue/increaseARPU.png'),
  revenue_icon_2: require('../Assets/Revenue/lifetimeValue.png'),
  revenue_icon_3: require('../Assets/Revenue/atNoCost.png'),
  loyalty_icon_1: require('../Assets/Loyalty/offers.png'),
  loyalty_icon_2: require('../Assets/Loyalty/inAppReward.png'),
  loyalty_icon_3: require('../Assets/Loyalty/esgSupport.png'),
  our_mission_1: require('../Assets/About/ourMission1.png'),
  our_mission_2: require('../Assets/About/ourMission2.png'),
  our_mission_3: require('../Assets/About/ourMission3.png'),
  amazonRoundLogo: require('../Assets/Network/Brands/amazon.png'),
  levisRoundLogo: require('../Assets/Network/Brands/levis.png'),
  adidasRoundLogo: require('../Assets/Network/Brands/adidas.png'),
  microsoftRoundLogo: require('../Assets/Network/Brands/microsoft.png'),
  samsungRoundLogo: require('../Assets/Network/Brands/samsung.png'),
  macysRoundLogo: require('../Assets/Network/Brands/macys.png'),
  gapRoundLogo: require('../Assets/Network/Brands/gap.png'),
  targetRoundLogo: require('../Assets/Network/Brands/target.png'),
  walmartRoundLogo: require('../Assets/Network/Brands/walmart.png'),
  tescoRoundLogo: require('../Assets/Network/Brands/tesco.png'),
  white_kindred_icon: require('../Assets/Branding/white_kindred_icon.png'),
  puzzle_icon: require('../Assets/Icons/puzzlePiece.png'),
  ios_checked_icon: require('../Assets/Icons/greenSwitch.png'),
  partnerpluginsdk_safari_activation_steps: require('../Assets/PartnerNewpluginsdkActivate/safari-activation-steps.png'),
  partnerpluginsdk_safari_activation_steps_ios_18: require('../Assets/PartnerNewpluginsdkActivate/safari-activation-steps-ios-18.png'),
  partnerpluginsdk_safari_activation_steps_ios_ipad: require('../Assets/PartnerNewpluginsdkActivate/safari-activation-steps-ipad.png'),
  partnerpluginsdk_safari_settings_steps: require('../Assets/PartnerNewpluginsdkActivate/safari-settings-steps.png'),
  partnerpluginsdk_safari_settings_steps_ios18: require('../Assets/PartnerpluginsdkActivate/safari-settings-steps-ios-18.png'),
  partnerpluginsdk_safari_settings_steps_ios_aa: require('../Assets/PartnerpluginsdkActivate/safari-settings-steps-ios-aa.png'),
  partnerpluginsdk_safari_settings_steps_ios_aa_ar: require('../Assets/PartnerpluginsdkActivate/safari-settings-steps-ios-aa-ar.png'),
  partnerpluginsdk_tap_here: require('../Assets/PartnerpluginsdkActivate/tap-here.png'),
  partnerpluginsdk_tap_here_ios_18: require('../Assets/PartnerpluginsdkActivate/tap-here-ios-18.png'),
  partnerpluginsdk_tap_here_ios_18_ar: require('../Assets/PartnerpluginsdkActivate/tap-here-ios-18-ar.png'),
  partnerpluginsdk_tap_aa_here: require('../Assets/PartnerpluginsdkActivate/tap-aa-here.png'),
  partnerpluginsdk_tap_aa_here_ar: require('../Assets/PartnerpluginsdkActivate/tap-aa-here-ar.png'),
  partnerpluginsdk_ios_18_plugin_icon: require('../Assets/PartnerpluginsdkActivate/ios-18-plugin-icon.png'),
  partnerpluginsdk_tap_here_sliide: require('../Assets/PartnerpluginsdkActivate/tap-here-sliide.png'),
  partnerpluginsdk_tap_here_top_left: require('../Assets/PartnerpluginsdkActivate/tap-here-top-left.png'),
  partnerpluginsdk_tap_here_bottom: require('../Assets/PartnerpluginsdkActivate/tap-here-bottom.png'),
  partnerpluginsdk_tap_here_top_left_sliide: require('../Assets/PartnerpluginsdkActivate/tap-here-top-left-sliide.png'),
  partnerpluginsdk_tap_here_bottom_sliide: require('../Assets/PartnerpluginsdkActivate/tap-here-bottom-sliide.png'),
  partnerpluginsdk_tap_here_top_left_itvx: require('../Assets/PartnerNewpluginsdkActivate/tap-here-top-left-itvx.png'),
  partnerpluginsdk_tap_here_bottom_itvx: require('../Assets/PartnerNewpluginsdkActivate/tap-here-bottom-itvx.png'),
  partnerpluginsdk_tap_review_itvx: require('../Assets/PartnerNewpluginsdkActivate/tap-review-itvx.png'),
  partnerpluginsdk_always_allow: require('../Assets/PartnerNewpluginsdkActivate/always-allow.png'),
  partnerpluginsdk_be_sure_1: require('../Assets/PartnerpluginsdkActivate/be-sure-step1.png'),
  partnerpluginsdk_be_sure_2: require('../Assets/PartnerpluginsdkActivate/be-sure-step2.png'),
  partnerpluginsdk_be_sure_3: require('../Assets/PartnerpluginsdkActivate/be-sure-step3.png'),
  partnerpluginsdk_be_sure_4: require('../Assets/PartnerpluginsdkActivate/be-sure-step4.png'),
  partnerpluginsdk_be_sure_5: require('../Assets/PartnerpluginsdkActivate/be-sure-step5.png'),
  partnerpluginsdk_be_suresliide_1: require('../Assets/PartnerpluginsdkActivate/be-sure-stepsliide1.png'),
  partnerpluginsdk_be_suresliide_2: require('../Assets/PartnerpluginsdkActivate/be-sure-stepsliide2.png'),
  partnerpluginsdk_be_suresliide_3: require('../Assets/PartnerpluginsdkActivate/be-sure-stepsliide3.png'),
  partnerpluginsdk_be_suresliide_4: require('../Assets/PartnerpluginsdkActivate/be-sure-stepsliide4.png'),
  partnerpluginsdk_be_suresliide_5: require('../Assets/PartnerpluginsdkActivate/be-sure-stepsliide5.png'),
  partnerpluginsdk_start_shopping_brands: require('../Assets/PartnerpluginsdkActivate/brands.png'),
  partnerpluginsdk_start_shopping_brands_sliide: require('../Assets/PartnerpluginsdkActivate/brandssliide.png'),
  partnerpluginsdk_activation_tim_review: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-activation-review.gif'),
  partnerpluginsdk_activation_tim_aa: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-activation-aa.gif'),
  partnerpluginsdk_activation_tim_18: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-activation-18.gif'),
  tim_ios_logo: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-logo.png'),
  tim_ios_partial_steps: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-partial-steps.png'),
  tim_ios_union_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-union-icon.png'),
  tim_ios_review_permissions: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-review-permissions.png'),
  tim_ios_switch_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-switch-icon.png'),
  tim_ios_plugin_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-plugin-icon.png'),
  tim_ios_18_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-18-icon.png'),
  tim_ios_success_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-ios-success-icon.png'),
  tim_app_store_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-app-store-icon.png'),
  tim_partial_logo: require('../Assets/PartnerNewpluginsdkActivate/tim-partial-logo.png'),
  tim_safari_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-safari-icon.png'),
  safari_browser_logo: require('../Assets/PartnerNewpluginsdkActivate/safari-browser-logo.png'),
  tim_settings_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-settings-icon.png'),
  tim_switch: require('../Assets/PartnerNewpluginsdkActivate/tim-switch.png'),
  tim_left_icon: require('../Assets/PartnerNewpluginsdkActivate/tim-left-icon.png'),
  samsung_activation_deals_found: require('../Assets/SamsungActivation/samsung-deals-found.png'),
  samsung_activation_you_saved_so_far: require('../Assets/SamsungActivation/samsung-saved-so-far.png'),
  samsung_activation_you_saved: require('../Assets/SamsungActivation/samsung-you-saved.png'),
  Itv_logo: require('../Assets/ITVLogos/itv@4x.png'),
  ItvX: require('../Assets/ITVLogos/itvX@4x.png'),
  dominos_logo: require('../Assets/ITVLogos/dominos@4x.png'),
  tree: require('../Assets/Icons/tree.png'),
  shoppingBag: require('../Assets/Icons/shopping-bag.png'),
  brands: require('../Assets/BrandLogos/brands.png'),
};

export const mockedLogos = {
  purple_kindred_icon: require('../Assets/Branding/purple_kindred_icon.png'),
  black_kindred_icon: require('../Assets/Branding/black_kindred_icon.png'),
  new_kindred_icon: require('../Assets/Branding/new_kindred_icon.png'),
  nike_logo: require('../Assets/BrandLogos/nike.png'),
  john_lewis_logo: require('../Assets/BrandLogos/john_lewis.png'),
  asos_logo: require('../Assets/BrandLogos/asos.png'),
  john_lewis_logo_white: require('../Assets/BrandLogos/john_lewis_logo_white.png'),
  typewise: require('../Assets/BrandLogos/typewise.png'),
  couponsde: require('../Assets/BrandLogos/couponsde.png'),
  eon: require('../Assets/BrandLogos/eon.png'),
  popreach: require('../Assets/BrandLogos/popreach.png'),
  whitelabel: require('../Assets/BrandLogos/whitelabel.png'),
  o2: require('../Assets/BrandLogos/o2.png'),
  unity: require('../Assets/BrandLogos/unity.png'),
  O2_logo: require('../Assets/O2Logos/O2-bubble-3D-animations-04@05x 1.png'),
};

export const mockedLogosTim = {
  tim_viva_ticket_logo: require('../Assets/BrandLogos/tim-viva-ticket-logo.png'),
  tim_asos_logo: require('../Assets/BrandLogos/tim-asos-logo.png'),
  tim_air_bnb_logo: require('../Assets/BrandLogos/tim-air-bnb-logo.png'),
  sephora_logo: require('../Assets/BrandLogos/sephora-logo.png'),
  tim_leroy_merlin_logo: require('../Assets/BrandLogos/tim-leroy-merlin-logo.png'),
  tim_decathlon_logo: require('../Assets/BrandLogos/tim-decathlon-logo.png'),
  tim_euronics_logo: require('../Assets/BrandLogos/tim-euronics-logo.png'),
  tim_zalando_logo: require('../Assets/BrandLogos/tim-zalando-logo.png'),
};

export const eonImages = {
  tap_here_bottom_ios_18: require('../Assets/Eon/tap_here_bottom_ios_18.png'),
  tap_here_bottom: require('../Assets/Eon/tap_here_bottom.png'),
  tap_here_top_left: require('../Assets/Eon/tap_here_top_left.png'),
  safari_settings_steps: require('../Assets/Eon/safari_settings_steps.png'),
  safari_settings_steps_ios_18: require('../Assets/Eon/safari_settings_steps_ios_18.png'),
  safari_settings_partial: require('../Assets/Eon/safari_settings_partial.png'),
  safari_tap_review: require('../Assets/Eon/safari_tap_review.png'),
  eon_header: require('../Assets/Eon/eon-header.png'),
  eon_header_generic: require('../Assets/Eon/eon-header-generic.png'),
  brands: require('../Assets/Eon/brands.png'),
  eon_logo_small: require('../Assets/Eon/eon_logo_small.png'),
  eon_white: require('../Assets/BrandLogos/eon-white.png'),
};

export const ntvImages = {
  ntv_logo: require('../Assets/NTV/ntv-logo.png'),
  ntv_brands: require('../Assets/NTV/ntv-brands.png'),
  tap_here_bottom_ios_18: require('../Assets/NTV/tap_here_bottom_ios_18.png'),
  tap_here_bottom: require('../Assets/NTV/tap_here_bottom.png'),
  tap_here_top_left: require('../Assets/NTV/tap_here_top_left.png'),
  safari_always_allow: require('../Assets/NTV/safari-always-allow.png'),
  safari_settings_partial: require('../Assets/NTV/safari_settings_partial.png'),
  ntv_brands_white: require('../Assets/NTV/ntv-brands-white.png'),
  safari_tap_review: require('../Assets/NTV/tap_here_top_right.png'),
};

export const nationalRailImages = {
  nationalRailBackground: require('../Assets/NationalRail/backgroundImage.png'),
  nationalRailLogo: require('../Assets/NationalRail/nationalRailLogo.png'),
  poweredByKindred: require('../Assets/NationalRail/poweredByKindred.png'),
  popularBrands: require('../Assets/NationalRail/popularBrands.png'),
};

export const blueLightCardImages = {
  blc_brands: require('../Assets/BlueLightCard/brands.png'),
  tap_here_bottom_ios_18: require('../Assets/BlueLightCard/tap_here_bottom_ios_18.png'),
  tap_here_bottom: require('../Assets/BlueLightCard/tap_here_bottom.png'),
  tap_here_top_left: require('../Assets/BlueLightCard/tap_here_top.png'),
  tap_here_top_left_ios_18: require('../Assets/BlueLightCard/tap_here_top_ios_18.png'),
  safari_setting_partial_arrow: require('../Assets/BlueLightCard/safari_setting_partial_arrow.png'),
  safari_setting_partial_1: require('../Assets/BlueLightCard/safari_setting_partial_1.png'),
  safari_setting_partial_2: require('../Assets/BlueLightCard/safari_setting_partial_2.png'),
  safari_setting_partial_3: require('../Assets/BlueLightCard/safari_setting_partial_3.png'),
  safari_setting_partial_4: require('../Assets/BlueLightCard/safari_setting_partial_4.png'),
  safari_setting_partial_5: require('../Assets/BlueLightCard/safari_setting_partial_5.png'),
  safari_setting_partial_6: require('../Assets/BlueLightCard/safari_setting_partial_6.png'),
  safari_tap_review: require('../Assets/BlueLightCard/safari_tap_review.png'),
  header_star: require('../Assets/BlueLightCard/header_star.png'),
  get_notifications: require('../Assets/BlueLightCard/get_notifications.png'),
  shop_anywhere: require('../Assets/BlueLightCard/shop_anywhere.png'),
  get_discounts: require('../Assets/BlueLightCard/get_discounts.png'),
  safari_settings: require('../Assets/BlueLightCard/safari_settings.png'),
  safari_settings_ios_17: require('../Assets/BlueLightCard/safari_settings_ios_17.png'),
  safari_settings_ipad: require('../Assets/BlueLightCard/safari_settings_ipad.png'),
  safari_settings_ios_17_ipad: require('../Assets/BlueLightCard/safari_settings_ios_17_ipad.png'),
  safari_always_allow: require('../Assets/BlueLightCard/always_allow.png'),
  safari_always_allow_everytime: require('../Assets/BlueLightCard/always_allow_on_every_site.png'),

  activate_icon: require('../Assets/BlueLightCard/activate_icon.png'),
};

export default images;
